import { Capacitor } from "@capacitor/core";

let initialized = false;
let nativeWakeLockEnabled = false;
let healthCheckInterval: ReturnType<typeof setInterval> | null = null;
let webWakeLock: WakeLockSentinel | null = null;

async function enableNative() {
  try {
    const { KeepAwake } = await import("@capgo/capacitor-keep-awake");
    await KeepAwake.keepAwake();
    nativeWakeLockEnabled = true;
    console.log("[WakeLock] Native enabled");

    // Verify
    try {
      const { isKeptAwake } = await KeepAwake.isKeptAwake();
      if (!isKeptAwake) {
        await KeepAwake.keepAwake();
        nativeWakeLockEnabled = true;
        console.log("[WakeLock] Native re-enabled after verification");
      }
    } catch {}
  } catch (err) {
    nativeWakeLockEnabled = false;
    console.error("[WakeLock] Native enable failed:", err);
  }
}

function startNativeHealthCheck() {
  if (healthCheckInterval) return;
  healthCheckInterval = setInterval(async () => {
    try {
      const { KeepAwake } = await import("@capgo/capacitor-keep-awake");
      const { isKeptAwake } = await KeepAwake.isKeptAwake();
      if (!isKeptAwake) {
        console.log("[WakeLock] Lost — re-acquiring");
        await KeepAwake.keepAwake();
        nativeWakeLockEnabled = true;
      }
    } catch {}
  }, 60_000);
}

async function bindNativeLifecycle() {
  try {
    const { App } = await import("@capacitor/app");
    App.addListener("appStateChange", ({ isActive }) => {
      if (isActive) void enableNative();
    });
    App.addListener("resume", () => {
      void enableNative();
    });
  } catch (err) {
    console.error("[WakeLock] Lifecycle bind failed:", err);
  }
}

async function acquireWebLock() {
  if (!("wakeLock" in navigator)) return;
  try {
    if (!webWakeLock) {
      webWakeLock = await navigator.wakeLock.request("screen");
      webWakeLock.addEventListener("release", () => {
        webWakeLock = null;
      });
      console.log("[WakeLock] Web enabled");
    }
  } catch {}
}

function initWeb() {
  acquireWebLock();
  document.addEventListener("visibilitychange", () => {
    if (document.visibilityState === "visible") void acquireWebLock();
  });
}

export function initWakeLock() {
  if (initialized) return;
  initialized = true;

  if (Capacitor.isNativePlatform()) {
    void enableNative();
    void bindNativeLifecycle();
    startNativeHealthCheck();
  } else {
    initWeb();
  }
}
